module.exports = __webpack_public_path__ + "img/OverseaMember02.a5762645.jpg";